import React from 'react';
import { Link } from 'react-router-dom';
import './hero.css';
import { Button } from '../../atoms/Buttons/Button';

const Hero: React.FC = () => {
  return (
    <section className="hero">
      <div className="hero-content">
        <h1>Welcome to Alvero Software Solutions</h1>
        <p>Your partner in innovative web development and custom software solutions.</p>
        <Link to="/contact" className="cta-button">
          <Button label={'Get Started'} primary={true}></Button>
        </Link>
      </div>
    </section>
  );
};

export default Hero;